/**
 * Current public policy versions displayed by the legal pages and acceptance modal.
 * These identify the bundled content; the server remains the acceptance authority.
 */
export const TERMS_VERSION = '2026-10-15-draft.1';

// These constants identify text bundled for display. Server status remains
// authoritative for acceptance and may require a version this client lacks.
export const PRIVACY_VERSION = '2026-10-15-draft.1';
